import {BaseConverter} from "../../base/converters/base-converter.converter";
import {CreatedOrderModel} from "../models/created-order.model";
import {CreatedOrder} from "../../shared/DTO/createdOrder";
import {OrderConverter} from "./order.converter";
import {Injectable} from "@angular/core";

@Injectable()
export class CreatedOrderConverter extends BaseConverter<CreatedOrderModel, CreatedOrder> {

  constructor(private orderConverter: OrderConverter) {
    super();
  }

  convertToDto(model: CreatedOrderModel): CreatedOrder {
    if (!model) {
      return;
    }
    return {
      pos: model.pos,
      createdDigitalSignOrder: this.orderConverter.convertToDto(model.createdDigitalSignOrder)
    };
  }

  convertToModel(dto: CreatedOrder): CreatedOrderModel {
    if (!dto) {
      return null;
    }
    let model: CreatedOrderModel = new CreatedOrderModel();
    model.createdDigitalSignOrder = this.orderConverter.convertToModel(dto.createdDigitalSignOrder);
    model.pos = dto.pos;
    return model;
  }
}
